import { Component, Input } from '@angular/core';
import { ErrorDesactivarSucursal, EstadosTraspaso } from '@config-empresa/sucursales/interfaces';

@Component({ standalone: false, selector: 'app-error-desactivar-sucursal-sociedad',
  templateUrl: 'error-desactivar-sucursal-sociedad.component.html'
})
export class ErrorDesactivarSucursalSociedadComponent {
  traduccionEstados: { [key in EstadosTraspaso]: string } = {
    E: 'derivación en la sucursal origen',
    G: 'enviar en sucursal origen',
    R: 'confirmar en la sucursal destino'
  };
  sucursalOrigenODestino: { [key in EstadosTraspaso]: 'sucursalOrigenNombre' | 'sucursalDestinoNombre' } = {
    E: 'sucursalOrigenNombre',
    G: 'sucursalOrigenNombre',
    R: 'sucursalDestinoNombre'
  };
  traspasos: { [key in EstadosTraspaso]: { [id: number]: { nombre: string; numTraspasos: number } } } = {
    E: [],
    G: [],
    R: []
  };
  @Input() set error(error: ErrorDesactivarSucursal) {
    if (!error) return;
    this.traspasos = error.traspasos.reduce((acc, traspaso) => {
      if (acc[traspaso.estado]) {
        const destinoOrigen_id = traspaso.estado === 'R' ? 'sucursalDestino_id' : 'sucursalOrigen_id';
        const destinoOrigenNombre = traspaso.estado === 'R' ? 'sucursalDestinoNombre' : 'sucursalOrigenNombre';
        if (acc[traspaso.estado][traspaso[destinoOrigen_id]]) {
          acc[traspaso.estado][traspaso[destinoOrigen_id]].numTraspasos += 1;
        } else {
          acc[traspaso.estado][traspaso[destinoOrigen_id]] = { nombre: traspaso[destinoOrigenNombre], numTraspasos: 1 };
        }
      }
      return acc;
    }, this.traspasos);
  }
  esVacio(traspaso: { [id: number]: { nombre: string; numTraspasos: number } }) {
    return (traspaso && (Object.keys(traspaso).length === 0));
 }
}
